import useContentProviders from 'app/hooks/useContentProviders';
import DataGrid from 'app/components/DataGrid';
import ContentProviderModal from './ContentProviderModal';

const ContentProviders = props => {
  const {
    resource,
    formIsOpen,
    currentRecord,
    onFormClose,
    onAdd,
    onEdit,
    onQuickAdd,
    onQuickEdit,
    onDataGridLoad,
    onFormSubmit,
    onDestroy,
    showFilters,
    getRowData
  } = useContentProviders();

  const header = 'Content Providers';
  const addButtonLabel = 'Add Content Provider';
  const columnOrder = ['account_name', 'client_provider_id', 'admin_email', 'access_token'];
  const visibleColumns = columnOrder;
  const omitColumns = ['access_token'];

  const columnDefOverrides = [
    {
      field: 'account_name',
      headerName: 'Account Name',
    },
    {
      field: 'client_provider_id',
      headerName: 'Client Provider ID'
    },
    {
      field: 'admin_email',
      headerName: 'Provider Admin Email'
    }
  ]

  const callback = selectedRows => {
    console.log(selectedRows);
    onDestroy(selectedRows);
  }

  const actions = [
    { key: 'destroy', label: 'Delete Content Provider', callback }
  ]

  return (
    <div>
      <DataGrid
        resource={resource}
        header={header}
        getRowData={getRowData}
        addButtonLabel={addButtonLabel}
        onAdd={onAdd}
        showEdit={true}
        onEdit={onEdit}
        showQuickEdit={true}
        columnOrder={columnOrder}
        visibleColumns={visibleColumns}
        columnDefOverrides={columnDefOverrides}
        omitColumns={omitColumns}
        showFilters={showFilters}
        showSelect={true}
        actions={actions}
        onDataGridLoad={onDataGridLoad}
        loadingMessage="Loading content providers..."
      />
      <ContentProviderModal
        isOpen={formIsOpen}
        onClose={onFormClose}
        contentProvider={currentRecord}
        onFormSubmit={onFormSubmit}
        onDestroy={onDestroy}
      />
    </div>
  )
}

export default ContentProviders;
